import React, { useState } from "react";
import Sidebar from "../../common/Sidebar/Sidebar";
import Header from "../../common/Header/Header";
import Api from "../../services/Api";
import { toast } from "react-toastify";
// import { toast } from "react-toastify";

const PushNotification = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendNotification = async () => {
    if (!title || !body) {
      toast.error("Title and Body are required!");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        title,
        body,
      };

      const response = await Api.sendNotification(payload);
      console.log("Notification Response:", response);

      toast.success("Notification sent successfully!");
      setTitle("");
      setBody("");
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error(error?.message || "Failed to send notification");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header title="Push Notification" />
        <div className="loaction-list-main mobile-list-main">
          <div className="setting-main mobile-home-main">
            <div className="setting-details">
              <h3>Send Push Notification to Users</h3>
              <div className="basic-detail">
                <div className="profile-details notification">
                  <div className="input-group flex">
                    <div className="input-field">
                      <label>Title</label>
                      <input
                        placeholder="Title"
                        value={title}
                        type="text"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 100) {
                            setTitle(value);
                          }
                        }}
                      />
                    </div>
                    <div className="input-field">
                      <label>Body</label>
                      <input
                        placeholder="Body"
                        value={body}
                        type="text"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 100) {
                            setBody(value);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="button-div">
                    <button onClick={handleSendNotification} disabled={loading}>
                      {loading ? "Sending..." : "Send Notification"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PushNotification;
